<template>
    <div v-if="banners.length > 0" class="banners">
        <div v-for="(item, index) in banners" class="banner" :key="index">
            <a :href="route('banners.redirect', item.id)" class="img" rel="nofollow">
                <img :src="'/storage/' + item.file" alt="" loading="lazy" />
            </a>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        banners: Object,
    }
}
</script>
<style scoped>
.banners {
    margin-bottom: 40px;
}

.banners .banner {
    margin-bottom: 20px;
}
.banners .banner .img{
    width: 100%;
}
</style>
